<template>
  <div v-if="showBanner && !dismissed" class="storage-warning-banner">
    <div class="d-flex align-items-center justify-content-center" style="gap: 0.5rem">
      <feather-icon icon="HardDriveIcon" size="14" />
      <span>Penyimpanan hampir penuh ({{ usagePercent }}%). Hapus file lama atau tambah kuota.</span>
      <b-button
        variant="light"
        size="sm"
        class="storage-banner-btn"
        @click="goToStorage"
      >
        Kelola Penyimpanan
      </b-button>
      <b-button
        variant="link"
        size="sm"
        class="storage-banner-close"
        @click="dismiss"
      >
        <feather-icon icon="XIcon" size="12" />
      </b-button>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from '@vue/composition-api'
import { BButton } from 'bootstrap-vue'
import { useStorageQuotaStore } from '@/pinia/storageQuota'

export default defineComponent({
  name: 'StorageWarningBanner',
  components: { BButton },
  setup(props, { root }) {
    const storageStore = useStorageQuotaStore()
    const DISMISS_KEY = 'storage_warning_dismissed'
    const dismissed = ref(!!sessionStorage.getItem(DISMISS_KEY))

    const showBanner = computed(() => storageStore.showWarningBanner)
    const usagePercent = computed(() => Math.round(storageStore.usagePercent))

    const goToStorage = () => {
      root.$router.push({ name: 'workspace', query: { tab: 'penyimpanan' } })
    }

    const dismiss = () => {
      dismissed.value = true
      sessionStorage.setItem(DISMISS_KEY, '1')
    }

    return {
      showBanner,
      usagePercent,
      dismissed,
      goToStorage,
      dismiss,
    }
  },
})
</script>

<style lang="scss" scoped>
.storage-warning-banner {
  position: sticky;
  top: 0;
  z-index: 1029;
  padding: 0.35rem 1rem;
  font-size: 0.78rem;
  font-weight: 500;
  text-align: center;
  background: #fff8e1;
  color: #f57f17;
  border-bottom: 1px solid rgba(255, 193, 7, 0.3);
}

.storage-banner-btn {
  padding: 0.15rem 0.5rem;
  font-size: 0.72rem;
  font-weight: 600;
  border-radius: 4px;
}

.storage-banner-close {
  padding: 0;
  color: inherit;
  opacity: 0.7;
  &:hover { opacity: 1; }
}
</style>
